import * as React from 'react';
import { LiteYoutubeEmbed } from 'react-lite-yt-embed';
import { TEST_ID } from '../../../../../constants';
import { IframeContainer } from './HeroAndHighlights.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const YouTubeIframe = _ref => {
  let {
    youtubeId
  } = _ref;
  return (
    /*#__PURE__*/
    // Extra div is here is necessary for intrinsic aspect ratio to work
    _jsx("div", {
      children: /*#__PURE__*/_jsx(IframeContainer, {
        "data-testid": TEST_ID.OVERVIEW_TAB_YOUTUBE_IFRAME,
        children: /*#__PURE__*/_jsx(LiteYoutubeEmbed, {
          // Adding a key prop to force remount the LiteYoutubeEmbed component.
          id: youtubeId,
          mobileResolution: "hqdefault",
          desktopResolution: "hqdefault"
        }, youtubeId)
      })
    })
  );
};
export default YouTubeIframe;